export const SET_FILES = 'SET_FILES'
export const SET_FILE = 'SET_FILE'
export const SET_THUMBS = 'SET_THUMBS'



// WEBPACK FOOTER //
// ./src/store/modules/files/types.js